export const PrevSvg = () => {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8165 5.12695L7.68994 10.2535L12.8165 15.3801" stroke="currentColor" strokeWidth="1.70886"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
